import React, { useState } from "react";
import { Alert, CircularProgress, Grid } from "@mui/material";
import MKTypography from "components/MKTypography";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";

export default function RFQForm() {
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState({ type: "", message: "" });
    const [form, setForm] = useState({
        nome: "", empresa: "", email: "", telefone: "", cidade: "",
        quantidade: 1, prazo: "", mensagem: "", arquivo: null, consent: false,
    });

    const onChange = (e) => {
        const { name, value, type, checked, files } = e.target;
        if (type === "file") setForm((p) => ({ ...p, arquivo: files?.[0] || null }));
        else if (type === "checkbox") setForm((p) => ({ ...p, [name]: checked }));
        else setForm((p) => ({ ...p, [name]: value }));
    };

    const validar = () => {
        const { nome, empresa, email, telefone, quantidade, consent } = form;
        if (!nome || !empresa || !email || !telefone || !quantidade) return "Preencha os campos obrigatórios.";
        if (!consent) return "É necessário aceitar o consentimento (LGPD).";
        return "";
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        setStatus({ type: "", message: "" });

        const err = validar();
        if (err) return setStatus({ type: "error", message: err });

        setLoading(true);

        try {
            const payload = {
                nome: form.nome,
                empresa: form.empresa,
                email: form.email,
                telefone: form.telefone,
                cidade: form.cidade,
                quantidade: form.quantidade,
                prazo: form.prazo,
                mensagem: form.mensagem,
                assunto: "Pedido de orçamento - Ramlis Machine",
            };

            console.log("JSON enviado:", payload);

            const resp = await fetch("https://ramlismachine.com.br/api/sendmail.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            const data = await resp.json();
            if (!resp.ok || !data.success)
                throw new Error(data.message || `Erro HTTP ${resp.status}`);

            setStatus({
                type: "success",
                message: "Pedido enviado com sucesso. Retornaremos em breve!",
            });

            setForm({
                nome: "",
                empresa: "",
                email: "",
                telefone: "",
                cidade: "",
                quantidade: 1,
                prazo: "",
                mensagem: "",
                arquivo: null,
                consent: false,
            });
        } catch (e2) {
            console.error("Erro ao enviar:", e2);
            setStatus({
                type: "error",
                message: e2?.message || "Não foi possível enviar. Tente novamente mais tarde.",
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={onSubmit} style={{ padding: 24 }}>

            <Grid container spacing={2}>
                <Grid item xs={12} md={6}><MKInput label="Nome" name="nome" value={form.nome} onChange={onChange} required fullWidth autoComplete="name" /></Grid>
                <Grid item xs={12} md={6}><MKInput label="Empresa" name="empresa" value={form.empresa} onChange={onChange} required fullWidth /></Grid>
                <Grid item xs={12} md={6}><MKInput type="email" label="E-mail" name="email" value={form.email} onChange={onChange} required fullWidth autoComplete="email" /></Grid>
                <Grid item xs={12} md={6}>
                    <MKInput label="Telefone" name="telefone" value={form.telefone} onChange={onChange} required fullWidth placeholder="(11) 99999-9999"
                        inputProps={{ inputMode: "tel", pattern: "[0-9()+\\-\\s]{8,}" }} autoComplete="tel" />
                </Grid>
                <Grid item xs={12} md={6}><MKInput label="Cidade/UF" name="cidade" value={form.cidade} onChange={onChange} fullWidth /></Grid>
                <Grid item xs={12} md={3}><MKInput type="number" label="Quantidade" name="quantidade" value={form.quantidade} onChange={onChange} required fullWidth inputProps={{ min: 1 }} /></Grid>
                <Grid item xs={12} md={3}><MKInput type="date" label="Prazo desejado" name="prazo" value={form.prazo} onChange={onChange} fullWidth InputLabelProps={{ shrink: true }} /></Grid>
                <Grid item xs={12}>
                    <MKInput multiline rows={4} label="Observações" name="mensagem" value={form.mensagem} onChange={onChange} fullWidth
                        placeholder="Dimensões críticas, tolerâncias, acabamento, dureza etc." />
                </Grid>
                {/* <Grid item xs={12}>
                    <div style={{ marginTop: 8 }}>
                        <input id="arquivo" name="arquivo" type="file" accept=".pdf,.step,.stp,.igs,.iges,.dwg,.dxf" onChange={onChange} required style={{ display: "block", width: "100%" }} />
                        <MKTypography variant="caption" color="text">Tamanho máximo: {MAX_SIZE_RFQ_MB} MB.</MKTypography>
                    </div>
                </Grid> */}
                <Grid item xs={12}>
                    <label
                        style={{
                            display: "flex",
                            alignItems: "flex-start",
                            columnGap: 8,
                            flexWrap: "nowrap",
                        }}
                    >
                        <input
                            type="checkbox"
                            name="consent"
                            checked={form.consent}
                            onChange={onChange}
                            required
                            style={{
                                marginTop: 2,
                                width: "auto",
                                display: "inline-block",
                                flex: "0 0 auto",
                            }}
                        />
                        <MKTypography variant="caption" color="text" sx={{ lineHeight: 1.4 }}>
                            Autorizo o tratamento dos meus dados para fins de orçamento (LGPD).
                        </MKTypography>
                    </label>
                </Grid>

                {status.message && (
                    <Grid item xs={12}><Alert severity={status.type === "success" ? "success" : "error"}>{status.message}</Alert></Grid>
                )}

                <Grid item xs={12} display="flex" gap={1.5} alignItems="center">
                    <MKButton type="submit" variant="gradient" color="info" disabled={loading}>
                        {loading ? (<><CircularProgress size={18} color="inherit" style={{ marginRight: 8 }} />Enviando…</>) : "Enviar pedido"}
                    </MKButton>
                </Grid>
            </Grid>
        </form>
    );
}
